import React from 'react';

/**
 * The useEditorFocus hook is a hack to focus on a calcite HTML component
 * when the component is mounted. This is needed because react-data-grid
 * does not properly focus the editor component when the cell is clicked.
 * @param fn - function to focus on the component
 * @param enabled - whether to focus on the component
 * @returns a ref to the component (pass this to the component's ref prop)
 */
export function useEditorFocus<T>(
  fn: (el: T) => void,
  enabled: boolean | undefined = false
): React.MutableRefObject<T | null> {
  const ref = React.useRef<T | null>(null);

  React.useEffect(() => {
    if (enabled) {
      // setTimeout is needed because the component is not mounted yet
      const timeout = setTimeout(() => {
        if (ref.current) fn(ref.current);
      }, 0);
      return () => clearTimeout(timeout);
    }
    // do not include fn in the dependency array because it will cause an infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, ref]);

  return ref;
}
